const RepeaterList = function () {

    // Só limita o número de linhas se algum sub-campo foi explicitamente
    // marcado com 'limit_rows' => true (vira data-repeater-limit="1") — não
    // assume mais "o primeiro select que aparecer", pra servir qualquer
    // combinação de sub-campos em repeaters futuros.
    const maxRows = function (list) {
        const limitSelect = list.find('.js-repeater-row').first().find('select[data-repeater-limit="1"]').first();

        if (limitSelect.length === 0) {
            return null;
        }

        return limitSelect.find('option[value!=""]').length;
    }

    // Botão e lista são sempre irmãos dentro do mesmo wrapper (ver form.blade.php),
    // então navega por proximidade no DOM em vez de casar por data-repeater-name —
    // evita cruzar instâncias se dois repeaters com o mesmo name coexistirem no DOM.
    const updateAddButtonState = function (list) {
        const limit = maxRows(list);
        const btn = list.parent().find('.js-repeater-add').first();

        btn.prop('disabled', limit !== null && list.find('.js-repeater-row').length >= limit);
    }

    const enforceUniqueSelects = function (list) {
        const groups = {};

        list.find('select[data-unique="1"]').each(function () {
            const field = $(this).data('repeater-field');
            groups[field] = groups[field] || [];
            groups[field].push(this);
        });

        Object.values(groups).forEach(function (selects) {
            const selectedValues = selects
                .map(function (el) { return el.value; })
                .filter(function (val) { return val !== ''; });

            selects.forEach(function (select) {
                $(select).find('option').each(function () {
                    if (this.value === '') {
                        return;
                    }

                    const pickedElsewhere = selectedValues.indexOf(this.value) !== -1 && this.value !== select.value;
                    this.disabled = pickedElsewhere;
                });
            });
        });
    }

    // Cada linha precisa de um name único (ex: campo[0][sub], campo[1][sub]) pro
    // jQuery Validation validar todas as linhas — ele só valida o 1º elemento
    // de cada name repetido, então name igual em todas as linhas não funciona.
    const reindexClone = function (clone, index) {
        clone.find('[name]').each(function () {
            const el = $(this);
            el.attr('name', el.attr('name').replace(/\[\d+\]/, '[' + index + ']'));
        });
    }

    const revalidate = function (list) {
        const form = list.closest('form');

        if (form.length > 0 && typeof window._formValidade === 'function') {
            window._formValidade(form);
        }
    }

    // Sub-campo com data-required-if="X" só fica obrigatório se o sub-campo X
    // da mesma linha tiver valor (ex: data só é obrigatória se o Mercado foi
    // selecionado). Usa uma função em vez de 'required:true' fixo, por isso é
    // aplicado direto aqui (data-validate/JSON não serializa função).
    const applyConditionalRequired = function (list) {
        if (typeof $.fn.rules !== 'function') {
            return;
        }

        list.find('[data-required-if]').each(function () {
            const input = $(this);
            const dependsOn = input.data('required-if');

            if (!dependsOn) {
                return;
            }

            input.rules('add', {
                required: function (element) {
                    return $(element).closest('.js-repeater-row').find('[data-repeater-field="' + dependsOn + '"]').val() !== '';
                },
                messages: { required: 'Este campo é obrigatório.' }
            });
        });
    }

    const addRow = function (event) {
        const list = $(event.currentTarget).parent().find('.js-repeater-list').first();

        if (list.length === 0) {
            return;
        }

        const limit = maxRows(list);
        if (limit !== null && list.find('.js-repeater-row').length >= limit) {
            return;
        }

        const clone = list.find('.js-repeater-row').first().clone();
        const nextIndex = parseInt(list.attr('data-repeater-next-index'), 10) || 0;

        reindexClone(clone, nextIndex);
        clone.find('select').prop('selectedIndex', 0);
        clone.find('input').val('');

        list.append(clone);
        list.attr('data-repeater-next-index', nextIndex + 1);

        updateAddButtonState(list);
        enforceUniqueSelects(list);
        revalidate(list);
        applyConditionalRequired(list);
    }

    const removeRow = function (event) {
        const row = $(event.currentTarget).closest('.js-repeater-row');
        const list = row.closest('.js-repeater-list');

        if (list.find('.js-repeater-row').length <= 1) {
            // sempre precisa sobrar 1 linha: é o template clonado pelo "Adicionar"
            row.find('select').prop('selectedIndex', 0);
            row.find('input').val('');
        } else {
            row.remove();
        }

        updateAddButtonState(list);
        enforceUniqueSelects(list);
    }

    const onSelectChange = function (event) {
        enforceUniqueSelects($(event.currentTarget).closest('.js-repeater-list'));
    }

    // Inicializa (ou reinicializa) todo .js-repeater-list presente no DOM agora.
    // Precisa rodar de novo toda vez que HTML novo é injetado via AJAX (troca de
    // step do produto) — por isso fica exposta em window, igual _formValidade.
    const initAllLists = function () {
        $('.js-repeater-list').each(function () {
            const list = $(this);
            updateAddButtonState(list);
            enforceUniqueSelects(list);
            // .rules('add') exige que .validate() já tenha rodado no form
            // (lê o validador em element.form); por isso revalidate() vem antes.
            revalidate(list);
            applyConditionalRequired(list);
        });
    }

    window._repeaterListInit = initAllLists;

    return {
        init: function () {
            $(document).on('click', '.js-repeater-add', addRow);
            $(document).on('click', '.js-repeater-remove', removeRow);
            $(document).on('change', '.js-repeater-list select[data-unique="1"]', onSelectChange);

            // Recalcula bem antes do dropdown abrir: cobre linhas que já vêm prontas
            // (edição de produto) e forms carregados depois via AJAX (troca de step),
            // casos em que o 'each' de inicialização abaixo já não alcança mais.
            $(document).on('mousedown focus', '.js-repeater-list select[data-unique="1"]', onSelectChange);

            $(function () {
                initAllLists();
            });
        }
    }
}();

module.exports = RepeaterList;
